module.exports = __webpack_public_path__ + "static/media/dadPhoto.9b4ebc28.jpeg";